/* global axios */
import ApiClient from './ApiClient';

class MetaAdsAPI extends ApiClient {
  constructor() {
    super('meta_ads_connections', { accountScoped: true });
  }

  // Returns the Meta OAuth dialog URL to redirect the admin to (fallback flow).
  generateAuthorization() {
    return axios.post(`${this.baseUrl()}/meta_ads/authorization`);
  }

  // Popup flow: exchange the OAuth code from FB.login for connected pages.
  connect(code) {
    return axios.post(this.url, { code });
  }

  // Contas de anuncio disponiveis pra uma conexao (pra marcar na config).
  adAccounts(connectionId) {
    return axios.get(`${this.baseUrl()}/meta_ads/ad_accounts`, {
      params: { connection_id: connectionId },
    });
  }

  // Salva as contas marcadas numa conexao (multiplas).
  saveAdAccounts(connectionId, selectedAdAccounts) {
    return axios.patch(`${this.url}/${connectionId}`, {
      selected_ad_accounts: selectedAdAccounts,
    });
  }

  // Marca/desmarca a pagina (assina/desassina o webhook de Lead Ads).
  saveLeadgen(connectionId, enabled) {
    return axios.patch(`${this.url}/${connectionId}`, { leadgen: enabled });
  }

  // Pixels do login (via contas marcadas), anotados com o estado do CAPI.
  pixels(connectionId) {
    return axios.get(`${this.baseUrl()}/meta_ads/pixels`, {
      params: { connection_id: connectionId },
    });
  }

  // Liga/desliga um pixel como destino de CAPI (cria a config na 1a vez).
  togglePixel(connectionId, pixel, enabled) {
    return axios.post(`${this.baseUrl()}/meta_ads/pixels/toggle`, {
      connection_id: connectionId,
      pixel_id: pixel.id,
      name: pixel.name,
      enabled,
    });
  }

  getAudiences() {
    return axios.get(`${this.baseUrl()}/meta_ads/audiences`);
  }

  createAudience(payload) {
    return axios.post(`${this.baseUrl()}/meta_ads/audiences`, payload);
  }

  syncAudience(id) {
    return axios.post(`${this.baseUrl()}/meta_ads/audiences/${id}/sync`);
  }

  deleteAudience(id) {
    return axios.delete(`${this.baseUrl()}/meta_ads/audiences/${id}`);
  }

  // range { since, until } em YYYY-MM-DD (periodo da barra de contexto).
  // Sem adAccountId, o backend AGREGA todas as contas marcadas na config
  // (nada de escolher 1 no relatorio). Devolve { data, accounts }.
  insights(adAccountId, range = {}) {
    const params = { since: range.since, until: range.until };
    if (adAccountId) params.ad_account_id = adAccountId;
    return axios.get(`${this.baseUrl()}/meta_ads/insights`, { params });
  }

  leadEvents() {
    return axios.get(`${this.baseUrl()}/meta_ads/lead_events`);
  }
}

export default new MetaAdsAPI();
